import { faCheck } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Field, useFormikContext, FieldArray } from "formik";
import { get, isEmpty, set } from "lodash";
import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import { useDeepEffect, useRequest } from "../../../abstracts";
import {
  FieldSingleButton,
  FieldInput,
  FieldInputDollar,
  FieldInputDecimal,
} from "../../../components";
import {
  checkRkPlanNumberExists,
  getPayrollFrequencies,
} from "../../../services";
import { usDateFormat } from "../../../utils";
import PayrollCompensationDetails from "./PayrollCompensationDetails";
import PayrollContributionDetails from "./PayrollContributionDetails";
import PayrollErrorReport from "./PayrollErrorReport";
import PayrollLoanDetails from "./PayrollLoanDetails";

const PayrollFormDetails = ({
  setIsLoading,
  fields,
  data,
  pendingSubmission,
  setId,
  errors,
  setError,
  setHoursErrorId,
  errorList,
  setErrors,
  setErrorList,
  frequencyList,
  isWarningSlide,
}) => {
  const formProps = useFormikContext();
  const { values, setFieldTouched, setFieldValue, handleChange } = formProps;
  const [plans, setPlans] = useState([]);
  useDeepEffect(() => {
    const contributionPlans = get(data, "contributions", []).map(
      (contribution) => contribution.rkPlanNumber
    );
    setPlans(
      contributionPlans.filter(
        (item, i, contributionPlans) => contributionPlans.indexOf(item) === i
      )
    );
  }, [data]);
  useDeepEffect(() => {
    setErrors(errorList);
  }, [errorList]);
  // useDeepEffect(() => {
  //   var tempError = {};
  //   get(data, "errorMessages", []).forEach((_) => {
  //     switch (_.controlName) {
  //       case "ytdHours":
  //         tempError["hoursDetails"] = [
  //           {
  //             ytdHours: _.messageDescCode,
  //           },
  //         ];
  //         break;

  //       case "payPeriodHours":
  //         tempError["hoursDetails"] = [
  //           {
  //             payPeriodHours: _.messageDescCode,
  //           },
  //         ];
  //         break;
  //       case "payPeriodGrossCompensation":
  //         set(tempError, "compensations[0].payPeriodAmount", _.messageDescCode);
  //         break;
  //       case "payPeriodPlanCompensation":
  //         set(tempError, "compensations[1].payPeriodAmount", _.messageDescCode);
  //         break;
  //       case "ytdGrossCompensation":
  //         tempError["compensations"] = [
  //           {
  //             ytdAmount: _.messageDescCode,
  //           },
  //           ...get(tempError, "compensations", []),
  //         ];
  //         break;
  //       case "ytdPlanCompensation":
  //         tempError["compensations"] = [
  //           ...get(tempError, "compensations", []),
  //           {
  //             ytdAmount: _.messageDescCode,
  //           },
  //         ];
  //         break;
  //       default:
  //         tempError[_.controlName] = _.messageDescCode;
  //         break;
  //     }
  //   });
  //   const contributions = get(data, "contributions", []);
  //   if (contributions != null && contributions.length > 0) {
  //     contributions?.forEach((_, i) => {
  //       _?.errorMessages?.forEach((x, ind) => {
  //         set(
  //           tempError, `${"contributions"}[${i}].${"contributionAmount"}`,
  //           x.messageDescCode
  //         );
  //       });
  //     });
  //   }
  //   const payrollLoansData = get(data, "payrollLoans", []);
  //   if (payrollLoansData != null && payrollLoansData.length > 0) {
  //     payrollLoansData?.forEach((_, i) => {
  //       _?.errorMessages?.forEach((x, ind) => {
  //         set(
  //           tempError,
  //           x.controlName == "loanNumber"
  //             ? `${fields.payrollLoans}[${i}].${x.controlName}`
  //             : `${fields.payrollLoans}[${i}].repaymentAmount`,
  //           x.messageDescCode
  //         );
  //       });
  //     });
  //   }
  //   setErrorList(tempError);
  // }, [data]);
  const payrollFrequecy =
    !isEmpty(frequencyList) &&
    frequencyList.filter((_) => {
      return _.id === data.payrollFrequencyId;
    });

  const errorPayPeriod = errors?.filter(
    (_) => _.controlName == "payPeriodHours" && _.errorType !== 4
  );

  const errorYtd = errors?.filter(
    (_) => _.controlName == "ytdHours" && _.errorType == 2
  );
  const handleHoursChnage = (e, num) => {
    const current = e.target.value;
    if (num === 1) {
      const prev = values?.hoursDetails?.[0]?.payPeriodHours;
      const ytdHrs = values?.hoursDetails?.[0]?.ytdHours + (current - prev);
      setFieldValue("hoursDetails[0].ytdHours", ytdHrs);
      handleChange(e);
    } else {
      const prev = values?.hoursDetails?.[0]?.ytdHours;
      const payPeriodHrs =
        values?.hoursDetails?.[0]?.payPeriodHours + (current - prev);
      setFieldValue("hoursDetails[0].payPeriodHours", payPeriodHrs);
      handleChange(e);
    }
  };
  console.log("values", values);
  return (
    <div className="d-flex">
      <div className="w-100">
        <div className="plan-sub-heading">Employee details</div>
        <Form.Group>
          <Form.Label>
            <div className="Ecr-Payroll-Details">Employee Name</div>
          </Form.Label>
          <div className="ft-14 font-weight-500">
            {get(data, "firstName", "") +
              " " +
              get(data, "middleName", "") +
              " " +
              get(data, "lastName", "")}
          </div>
        </Form.Group>
        <Form.Group>
          <Form.Label>
            <div className="Ecr-Payroll-Details">Employee ID</div>
          </Form.Label>
          <div className="ft-14 font-weight-500">
            {data.employeeNumber ? data.employeeNumber : "NA"}
          </div>
        </Form.Group>
        <Form.Group>
          <Form.Label>
            <div className="Ecr-Payroll-Details">Employee status</div>
          </Form.Label>
          <div className="ft-14 font-weight-500">
            {data.employmentStatus ? data.employmentStatus : "NA"}
          </div>
        </Form.Group>
        <Form.Group>
          <Form.Label>
            <div className="Ecr-Payroll-Details">Most recent term date</div>
          </Form.Label>
          <div className="ft-14 font-weight-500">
            {data.terminationDate ? usDateFormat(data.terminationDate) : "NA"}
          </div>
        </Form.Group>
        <Form.Group>
          <Form.Label>
            <div className="Ecr-Payroll-Details">Payroll frequency</div>
          </Form.Label>
          {payrollFrequecy && payrollFrequecy[0] ? (
            <div className="ft-14 font-weight-500">
              {payrollFrequecy[0].name}
            </div>
          ) : (
            <div className="ft-14 font-weight-500">{"NA"}</div>
          )}
        </Form.Group>
        <Form.Group>
          <Form.Label>
            <div className="Ecr-Payroll-Details">Highly compensated</div>
          </Form.Label>
          <div className="ft-14 font-weight-500">
            {data.hce === "Y" ? "Yes" : "No"}
          </div>
        </Form.Group>
        <Form.Group>
          <Form.Label>
            <div className="Ecr-Payroll-Details">Hire date</div>
          </Form.Label>
          <div className="ft-14 font-weight-500">
            {data.hireDate ? usDateFormat(data.hireDate) : "NA"}
          </div>
        </Form.Group>
        <Form.Group>
          <Form.Label>
            <div className="Ecr-Payroll-Details">Most recent rehire date</div>
          </Form.Label>
          <div className="ft-14 font-weight-500">
            {data.reHireDate ? usDateFormat(data.reHireDate) : "NA"}
          </div>
        </Form.Group>
        <Field
          size="xs"
          name={fields.annualSalary}
          type="text"
          autoComplete="off"
          label="Annual Salary"
          disabled={true || pendingSubmission || isWarningSlide}
          value={parseFloat(values[fields.annualSalary])}
          component={FieldInputDollar}
        />

        <FieldArray name={fields.hoursDetails}>
          {() => {
            return (
              <>
                <Field
                  size="xs"
                  name={"hoursDetails[0].payPeriodHours"}
                  autoComplete="off"
                  label="Pay Period Hours"
                  noLabelTransform={true}
                  value={
                    get(values, `hoursDetails[0].payPeriodHours`) === null
                      ? ""
                      : get(values, `hoursDetails[0].payPeriodHours`)
                  }
                  onChange={(e) => {
                    handleHoursChnage(e, 1);
                  }}
                  disabled={
                    values[fields.modeOfHours] != 1 ||
                    pendingSubmission ||
                    isWarningSlide
                  }
                  errorId={!isEmpty(errorPayPeriod) && errorPayPeriod[0].id}
                  setErrorId={setHoursErrorId}
                  hide={
                    values[fields.modeOfHours] == 1 &&
                    !isEmpty(errorPayPeriod) &&
                    errorPayPeriod[0].errorType !== 1 &&
                    !isWarningSlide
                  }
                  isCensusPayrollError={true}
                  max={9999}
                  component={FieldInputDecimal}
                />
                <Field
                  size="xs"
                  name={"hoursDetails[0].ytdHours"}
                  label="YTD Hours"
                  noLabelTransform={true}
                  autoComplete="off"
                  value={
                    get(values, `hoursDetails[0].ytdHours`) === null
                      ? ""
                      : get(values, `hoursDetails[0].ytdHours`)
                  }
                  onChange={(e) => {
                    handleHoursChnage(e, 2);
                  }}
                  disabled={
                    values[fields.modeOfHours] == 1 ||
                    pendingSubmission ||
                    isWarningSlide
                  }
                  errorId={!isEmpty(errorYtd) && errorYtd[0].id}
                  setErrorId={setHoursErrorId}
                  hide={
                    values[fields.modeOfHours] != 1 &&
                    !isEmpty(errorYtd) &&
                    !isWarningSlide
                  }
                  max={9999}
                  isCensusPayrollError={true}
                  component={FieldInputDecimal}
                />
              </>
            );
          }}
        </FieldArray>

        <p className="plan-sub-heading mtb5">Plan ID</p>
        <Field
          isRequired
          size="sm"
          disabled={pendingSubmission || isWarningSlide}
          name={fields.planId}
          noLabelTransform
          options={plans.map((plan) => ({
            label: (
              <>
                {values[fields.planId] === plan && (
                  <FontAwesomeIcon icon={faCheck} className="mr-1" />
                )}
                {plan}
              </>
            ),
            value: plan,
          }))}
          selectedValue={values[fields.planId]}
          value={values[fields.planId]}
          onChange={(value) => {
            setFieldValue(fields.planId, value);
          }}
          component={FieldSingleButton}
        />

        <PayrollCompensationDetails
          fields={fields}
          pendingSubmission={pendingSubmission}
          data={get(data, "compensations", [])}
          error={errors}
          errorList={errorList}
          setErrors={setErrors}
          compensationError={setError}
          isWarningSlide={isWarningSlide}
        />

        <PayrollContributionDetails
          fields={fields}
          pendingSubmission={pendingSubmission}
          data={get(data, "contributions", [])}
          contributionId={setId}
          errorList={errorList}
          setErrorList={setErrorList}
          menu={"payroll"}
          subMenu={"uploadFile"}
          isWarningSlide={isWarningSlide}
        />
        {/* <PayrollLoanDetails
          fields={fields}
          data={get(data, "payrollLoans", [])}
          menu={"payroll"}
          subMenu={"uploadFile"}
        /> */}
        <PayrollErrorReport
          fields={fields}
          pendingSubmission={pendingSubmission}
          errorList={errorList}
          data={get(data, "payrollLoans", [])}
          menu={"payroll"}
          subMenu={"uploadFile"}
          isWarningSlide={isWarningSlide}
        />
      </div>
    </div>
  );
};

export default PayrollFormDetails;
